import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Sparkles, TrendingUp } from 'lucide-react';
interface JUVCreditCounterProps {
  balance: number;
}
const JUVCreditCounter = ({
  balance
}: JUVCreditCounterProps) => {
  return <Card className="relative overflow-hidden bg-gradient-to-br from-juv-terracotta to-juv-deep-chestnut text-white border-0 shadow-editorial">
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
      <CardContent className="relative z-10 p-8">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-juv-cream-white/80">
              <Sparkles className="w-5 h-5" />
              <span className="text-sm font-medium">JUV Credit Balance</span>
            </div>
            <motion.div initial={{
            scale: 0.8
          }} animate={{
            scale: 1
          }} transition={{
            duration: 0.5,
            ease: "easeOut"
          }}>
              <h2 className="text-4xl font-bold tracking-tight text-slate-50">
                ${balance.toFixed(2)}
              </h2>
            </motion.div>
            <p className="text-juv-cream-white/70 text-sm">Available to spend</p>
          </div>
          <div className="hidden md:flex flex-col items-center space-y-3">
            <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
              <TrendingUp className="w-8 h-8 text-juv-cream-white" />
            </div>
            <span className="text-xs text-juv-cream-white/60 text-center">Growing<br />Daily</span>
          </div>
        </div>
      </CardContent>
    </Card>;
};
export default JUVCreditCounter;